import { render, staticRenderFns } from "./PropertyOverview.vue?vue&type=template&id=03b24578"
import script from "./PropertyOverview.vue?vue&type=script&lang=ts"
export * from "./PropertyOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports